<mat-card class="mat-mdc-card mdc-card cardWithShadow card2 position-relative">
    <mat-card-content class="mat-mdc-card-content p-y-24">
        <section>
            <h3 class="spanTitle">{{ 'about' | translate }} {{ 'AppTitle' | translate }}</h3>
            <p> {{CompanyInfo?.companyInfo}}</p>

            <h3 class="spanTitle">{{ 'futureInfo' | translate }}</h3>
            <p> {{CompanyInfo?.futureInfo}}</p>

            <p class="download" (click)="DownLoadCompanyFile(CompanyInfo?.companyFile)">
                <i-tabler name="download" class="icon-15 m-r-4"></i-tabler>
                {{ 'DownLoadCompanyFile' | translate }}
            </p>

            <h3 class="spanTitle">{{ 'Products' | translate }}</h3>

            <div *ngIf="!ProductsList;then NoProducts else Products"></div>

            <ng-template #NoProducts>
                <div class="col-md-12">
                    <p> {{ 'NoDataFound' | translate }}</p>
                </div>
            </ng-template>

            <ng-template #Products>
                <div class="row">
                    <div class="col-lg-3" *ngFor="let product of ProductsList">
                        <mat-card class="mat-mdc-card mdc-card cardWithShadow card2 position-relative card-hover">
                            <img alt="{{product.title}}" class="product-img" src="{{product.img}}">

                            <mat-card-content class="mat-mdc-card-content p-y-24">
                                <mat-card-title class="mat-mdc-card-title">{{product.title}}</mat-card-title>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </ng-template>
        </section>

        <footer>
            <app-social></app-social>
        </footer>
    </mat-card-content>
</mat-card>
